import React, {useState, useEffect} from "react";
import useStyles from "./styles";
import { FormGroup, InputBase, FormHelperText, FormControl, MenuItem, Select } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import axios from "../../../api/axios";
import ApmPayButton from '../ApmPayButton';

const IDeal = ({ currentPaymentSystem, formik, errorString, paymentInfo }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  
  return (
    <div className={classes.wrapper}>
      <ApmPayButton currentPaymentSystem={currentPaymentSystem} errorString={errorString} />
    </div>
  )
}

export default IDeal
